import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/contact-form',
    name: 'Contact Form',
    component: () => import('../views/contact-form.vue'),
      children: [
          {
              path: "*",
              name: "Contact Form",
              component: () => import('../views/contact-form.vue'),
          }
      ]
  },
  {
    path: '/contact-form-v2',
    name: 'Contact Form',
    component: () => import('../views/contact-form-v2.vue'),
      children: [
          {
              path: "*",
              name: "Contact Form",
              component: () => import('../views/contact-form-v2.vue'),
          }
      ]
  },
  {
    path: '/delivery-issues',
    name: 'delivery-issues',
    component: () => import('../views/delivery-issues.vue'),
      children: [
          {
              path: "*",
              name: "Contact Form",
              component: () => import('../views/delivery-issues.vue'),
          }
      ]
  },
  {
    path: '/cancellation-form',
    name: 'cancellation form',
    component: () => import('../views/cancellation-form.vue'),
    children: [
        {
            path: "*",
            name: 'cancellation form',
            component: () => import('../views/cancellation-form.vue'),
        }
    ]
  },
  {
    path: '/complaint-form',
    name: 'complaint form',
    component: () => import('../views/complaint-form.vue'),
    children: [
        {
            path: "*",
            name: 'complaint form',
            component: () => import('../views/complaint-form.vue'),
        }
    ]
  },
  {
    path: '/request-callback',
    name: 'request callback',
    component: () => import('../views/request-callback.vue'),
    children: [
        {
            path: "*",
            name: 'request callback',
            component: () => import('../views/request-callback.vue'),
        }
    ]
  },
  {
    // This is a development only space 
    path: '/x7hzz21',
    name: 'Contact Form',
    component: () => import('../views/development/contact-form-v2.vue'),
      children: [
          {
              path: "*",
              name: "Contact Form",
              component: () => import('../views/development/contact-form-v2.vue'),
          }
      ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
